import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Alert, Card } from "react-bootstrap";
import WalletItem from "./Component/WalletItem";
import { useNavigate } from "react-router-dom";
// import TransactionItem from "../Transaction/Component/TransactionItem";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import ApiUserWallet from "../../../core/api/api.userWallet";
import SplitNumber from "../../components/SplitNumber";
import ContextApp from "./../../../core/contexts/context.app";
import _ from "lodash";
// import { ToastContainer } from "react-toastify";
import ServiceStorage from "../../../core/services/service.storage";
import walletImage from "../../../assets/images/wallet-pana.svg";
import {
  // IconWallet,
  IconWallet1,
  IconWalletDeposit,
  IconWalletRequest,
  IconWalletTransition,
  IconWalletWithdraw,
} from "../../../assets/icons";

function WalletUser() {
  const [liveData, setLiveData] = useState({
    userTransactions: [],
  });
  const ctx = useContext(ContextApp);
  const iconWalletDeposit = <IconWalletDeposit />;
  const iconWalletTransition = <IconWalletTransition />;
  const iconWalletRequest = <IconWalletRequest />;
  const iconWalletWithdraw = <IconWalletWithdraw />;
  const navigate = useNavigate();
  useEffect(() => {
    if (ctx.isAuth) getData();
    else {
      navigate("/login");
    }
  }, [ctx.isAuth]);

  async function getData() {
    try {
      // گرفتن کیف پول
      const response = await ApiUserWallet.getUserWallet();

      if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
        setLiveData(response.data);

        let userInfo = ServiceStorage.getUserInfo();

        if (userInfo != null) {
          userInfo.walletRiallBalance = response.data.riallBalance;
          userInfo.walletAvailableRiallBalance =
            response.data.useAvailableRiallBalance;
          //ویرایش اطلاعات کاربر
          ServiceStorage.setUserInfo(userInfo);
          ctx.setUserInfo(userInfo);
        }
      }
    } catch (error) {}
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <ToastContainer></ToastContainer> */}
      <Container
        fluid
        className={!isMobile ? "main-content   " : "main-content  vh-100"}
      >
        <Container>
          <Row>
            <Col xs={12} lg={7} className="pt-xl-5 pt-3 pt-lg-3 icon-menu">
              <Card className="rounded-3 mb-2 mb-lg-3">
                <Card.Body>
                  <div className="d-flex large-icons">
                    <IconWallet1 fillColor="#000" />
                    <div className=" ps-3">
                      <div className="text-black-06 fs-075">موجودی کیف پول</div>

                      <div className="fw-bold fs-103">
                        <SplitNumber number={liveData.riallBalance} /> تومان
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Row className="text-small gx-2 gx-lg-3">
                <WalletItem
                  Icon={iconWalletDeposit}
                  PageLink="/wallet"
                  Title="شارژ کیف پول"
                  Event={1}
                  RiallBalance={liveData.useAvailableRiallBalance}
                />
                <WalletItem
                  Icon={iconWalletWithdraw}
                  // PageLink="/withdrowFromWallet"
                  PageLink="/wallet"
                  Title="برداشت وجه"
                  Event={2}
                  RiallBalance={liveData.useAvailableRiallBalance}
                />
                <WalletItem
                  Icon={iconWalletRequest}
                  PageLink="/withdrow"
                  Title="درخواست های برداشت"
                />
                <WalletItem
                  Icon={iconWalletTransition}
                  PageLink="/transaction"
                  Title="تراکنش های کیف پول"
                />
              </Row>
            </Col>
            {isMobile ? null : (
              <>
                <Col lg={5} className="text-left">
                  <img src={walletImage} alt="wallet" className="w-100" />
                </Col>
                {/* <Col xs={12} className="">
                  <div className="mb-2 mt-1 rounded-4">
                    <Row>
                      {liveData != null &&
                      liveData.userTransactions != null &&
                      liveData.userTransactions.length > 0 ? (
                        <>
                          <div className="text-line">
                            <span className="bg-light py-2 px-3">
                              {liveData.userTransactions.length} تراکنش آخر کیف
                              پول
                            </span>
                          </div>
                          {liveData.userTransactions?.map((itemData, index) => (
                            <TransactionItem
                              key={index}
                              ItemCharge={itemData.status}
                              ItemPrice={itemData.amount}
                              Amount={itemData.riallBalance}
                              ItemTime={itemData.completionTime}
                              ItemDate={itemData.completionDate}
                              ItemDescription={itemData.description}
                              Title={
                                !_.isEmpty(itemData.trackingCode)
                                  ? "کد پیگیری : "
                                  : ""
                              }
                              ItemCode={
                                !_.isEmpty(itemData.trackingCode)
                                  ? itemData.trackingCode
                                  : ""
                              }
                            />
                          ))}
                        </>
                      ) : (
                        <Alert variant="danger" className="w-100">
                          <p className="text-center">
                            اطلاعاتی برای نمایش وجود ندارد.
                          </p>
                        </Alert>
                      )}
                    </Row>
                  </div>
                </Col> */}
              </>
            )}
          </Row>
        </Container>
      </Container>
    </>
  );
}
export default WalletUser;
